// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.consultbd {
  border: 1px solid #000000;
  padding: 40px;
  margin: 100px auto 60px auto;
}`, "",{"version":3,"sources":["webpack://./src/pages/contact/styles/contact.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,aAAA;EACA,4BAAA;AACJ","sourcesContent":[".consultbd{\n    border: 1px solid #000000;\n    padding: 40px;\n    margin: 100px auto 60px auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
